import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderRadius4, colorBgBase, space12, space8, space16, space6 } = theme();

  return StyleSheet.create({
    balanceBanner: {
      marginTop: space6,
    },
    detailLarge: {
      backgroundColor: colorBgBase,
      borderRadius: borderRadius4,
      paddingVertical: space6,
    },
    detailSmall: {
      backgroundColor: colorBgBase,
    },
    detailWrapperLarge: {
      marginBottom: space12,
      paddingRight: space16,
    },
    fullWidthButton: {
      width: "100%",
    },
    infoBox: {
      paddingHorizontal: space6,
    },
    layout: {
      paddingVertical: space12,
    },
    resumeWrapper: {
      padding: space6,
    },
    resumeWrapperLarge: {
      backgroundColor: colorBgBase,
      borderRadius: borderRadius4,
    },
    returnButton: {
      marginTop: space8,
    },
  });
};

export { style };
